import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import loadConfig from "../../Services/apiService";
import ExpectedObjectivesForStagea from "../../PagesReportStage/ExpectedObjectivesForStagea";
import InformationSocialMediaPage from "../../PagesReportStage/InformationSocialMediaPage";
import InformationWebsitePage from "../../PagesReportStage/InformationWebsitePage";
import InformationAppPage from "../../PagesReportStage/InformationAppPage";
import LessonsLearnedPage from "../../PagesReportStage/LessonsLearnedPage";
import ButtonAHSF from "../../Components/ButtonAHSF";
import OpportunitiesObtained from "../../PagesReportStage/OpportunitiesObtained";
import ChallengesEncountered from "../../PagesReportStage/ChallengesEncounteredThatAffected";
import EventsActivities from "../../PagesReportStage/EventsActivities";
import EventsActivitiesNextFlow from "../../PagesReportStage/EventsActivitiesNextFlow";
import SuccessStory from "../../PagesReportStage/SuccessStory";
import { ValidationAllPageReports } from "../../Redux/Reducers/ReportStage/ValidateReportStage";
import JobOpportunitiesDuringProject from "../../PagesReportStage/JobOpportunitiesDuringProject";

import RS_AdminStrativeStage from "../../PagesReportStage/RS_AdminStrativeStage";
import RS_DirectCost from "../../PagesReportStage/RS_DirectCost";

import { GetReportStageByID } from "../../Redux/Reducers/ReportStage/Stages";
import LoaderAHSF from "../../Components/LoaderAHSF";
import { decryptToken } from "../../Services/Account/EncryptionParams";
import { GetReportByAppGuid } from "../../Redux/Reducers/ReportStage/Report";
import { WorkFlowReport } from "../../Redux/Reducers/ReportStage/WorkFlowReport";

const ReportStageContainer = (props) => {
  const dispatch = useDispatch(); // Used to dispatch Redux actions.
  let { stageGuid } = useParams();
  const [canEdit, setCanEdit] = useState(false);
  const [show, setshow] = useState(false);
  // فك تشفير ال  param
  console.log(props.location
    , "sdsdwdASdad");

  stageGuid = decryptToken(stageGuid);
  const state = useSelector((state) => {
    return {
      ValidateReportStage: state.ValidateReportStage.ValidateReportStage,
      loadingReportsStagesById:
        state.TypeOfJobOpportunityDropDown.loadingReportsStagesById,
      reports: state.ReportByAppGuidReducers.ReportByApp,
    };
  });

  const getReportStage = async () => {
    const reportStage = await dispatch(GetReportStageByID(stageGuid));

    if (reportStage.payload) {
      if (
        reportStage.payload?.currentStage ==
        reportStage.payload?.pR_StagesNumberId &&
        reportStage.payload?.canEdit
      ) {
        setCanEdit(true);
      }
      setshow(true);
    }
  };
  useEffect(() => {
    getReportStage();

    dispatch(
      GetReportByAppGuid({
        aI_ApplicationInformationId: localStorage.getItem(
          "aI_ApplicationInformationId"
        ),
      })
    );
  }, []);
  const validatePage = async () => {
    var validate = await dispatch(ValidationAllPageReports(stageGuid));
    console.log(validate);
    
    if (validate.payload?.length == 0) {
      dispatch(
        WorkFlowReport({
          pR_ReportActionFlowGuid: "54e0efc7-6248-42f4-9a84-9d35302ac33f",
          pR_ReportsId: state.reports?.pR_ReportsId,
          appGuid: localStorage.getItem("aI_ApplicationInformationId"),
        })
      );
    }
  };
  console.log(stageGuid, "sadasdwewdsA");

  return (
    <>


      

      {
      !state.loadingReportsStagesById && show ? (

        <SharedDiv
          showTitle={true}
          titleName="التقرير المرحلي"
          child={[
            <>
              <ExpectedObjectivesForStagea
                pR_ReportsStagesGuid={stageGuid}
                canEdit={canEdit}
              />
              <JobOpportunitiesDuringProject
                pR_ReportsStagesGuid={stageGuid}
                canEdit={canEdit}
              />
              <InformationSocialMediaPage
                pR_ReportsStagesGuid={stageGuid}
                canEdit={canEdit}
              />
              <InformationWebsitePage
                pR_ReportsStagesGuid={stageGuid}
                canEdit={canEdit}
              />
              <InformationAppPage
                pR_ReportsStagesGuid={stageGuid}
                canEdit={canEdit}
              />
              <OpportunitiesObtained
                pR_ReportsStagesGuid={stageGuid}
                canEdit={canEdit}
              />
              <ChallengesEncountered
                pR_ReportsStagesGuid={stageGuid}
                canEdit={canEdit}
              />
              <EventsActivities
                pR_ReportsStagesGuid={stageGuid}
                canEdit={canEdit}
              />
              <EventsActivitiesNextFlow
                pR_ReportsStagesGuid={stageGuid}
                canEdit={canEdit}
              />
              <LessonsLearnedPage
                pR_ReportsStagesGuid={stageGuid}
                canEdit={canEdit}
              />
              <SuccessStory
                pR_ReportsStagesGuid={stageGuid}
                canEdit={canEdit}
              />

              <RS_AdminStrativeStage location="manager" />
              <RS_DirectCost location="manager" />


              {
              canEdit &&props.location!="manager"? <>

              <RS_AdminStrativeStage />
              <RS_DirectCost />
              </>:<></>
              }
              
              {canEdit ? (

                <div style={{ justifyItems: "center", padding: "1%" }}>
                  <ButtonAHSF
                    type={"submitter"}
                    onClick={() => {
                      validatePage();
                    }}
                    disabled={false}
                    title={"تقديم التقرير المرحلي"}
                    text={"تقديم التقرير المرحلي"}
                    show={true}
                  />
                </div>
              ) : (
                ""
              )}



            </>,
          ]}




        />
      ) : (
        ""
      )}
      <LoaderAHSF show={state.loadingReportsStagesById} />
    </>
  );
};
export default ReportStageContainer;
